import React, { useEffect, useState } from 'react';

// Pantalla pública de solo lectura para la TV/tablet del local.
// Muestra el turno actual (o uno por caja) en grande y se actualiza
// por websocket con polling de respaldo.
function Display({ clientToken }) {
  const [data, setData] = useState(null);
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (!clientToken) return undefined;

    const fetchData = () => {
      fetch(`/api/locales/${clientToken}/display/`)
        .then(res => res.json())
        .then(json => setData(json))
        .catch(() => {});
    };

    fetchData();
    const interval = setInterval(fetchData, 3000);

    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const ws = new WebSocket(`${protocol}://${window.location.host}/ws/turnos/${clientToken}/`);
    ws.onmessage = () => {
      fetchData();
      setFlash(true);
      setTimeout(() => setFlash(false), 1500);
    };

    return () => {
      clearInterval(interval);
      ws.close();
    };
  }, [clientToken]);

  if (!data) {
    return <div style={styles.screen}><p style={styles.loading}>Cargando…</p></div>;
  }

  if (data.error) {
    return <div style={styles.screen}><p style={styles.loading}>Link inválido</p></div>;
  }

  const turnos = data.turnos_actuales || [];
  const multiPuesto = data.cantidad_puestos > 1;

  return (
    <div style={{ ...styles.screen, ...(flash ? styles.screenFlash : {}) }}>
      <style>{animaciones}</style>

      <header style={styles.header}>
        <h1 style={styles.local}>{data.nombre_local}</h1>
        <p style={styles.sucursal}>({data.sucursal})</p>
      </header>

      {turnos.length === 0 ? (
        <div style={styles.sinLlamados}>
          <p style={styles.sinLlamadosTexto}>
            {data.abierto ? 'Esperando el próximo llamado…' : '⛔ Local cerrado'}
          </p>
        </div>
      ) : data.modo === 'resto' ? (
        <div style={styles.unicoWrap}>
          <p style={styles.unicoLabel}>MESA LISTA PARA</p>
          <div style={styles.restoNumeros}>
            {turnos.map(t => (
              <span key={t.numero} style={styles.restoNumero} className={flash ? 'dp-pop' : ''}>
                {t.numero}
              </span>
            ))}
          </div>
        </div>
      ) : multiPuesto ? (
        <div style={styles.puestosGrid}>
          {turnos.map(t => (
            <div key={t.puesto} style={styles.puestoCard} className={flash ? 'dp-pop' : ''}>
              <p style={styles.puestoLabel}>CAJA {t.puesto}</p>
              <p style={styles.puestoNumero}>{t.numero}</p>
            </div>
          ))}
        </div>
      ) : (
        <div style={styles.unicoWrap}>
          <p style={styles.unicoLabel}>TURNO ACTUAL</p>
          <p style={styles.unicoNumero} className={flash ? 'dp-pop' : ''}>{turnos[0].numero}</p>
        </div>
      )}

      <footer style={styles.footer}>
        <p style={styles.espera}>
          {data.modo === 'resto' ? 'Grupos en espera' : 'En espera'}: <strong>{data.en_espera}</strong>
        </p>
      </footer>
    </div>
  );
}

const animaciones = `
@keyframes dpPop {
  0% { transform: scale(0.7); }
  60% { transform: scale(1.12); }
  100% { transform: scale(1); }
}
.dp-pop { animation: dpPop 0.6s ease-out; }
`;

const styles = {
  screen: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4vh 4vw',
    background: '#0b1f1a',
    color: '#f3f7f5',
    fontFamily: 'Arial',
    textAlign: 'center',
    transition: 'background 0.4s'
  },
  screenFlash: {
    background: '#0f7b6c'
  },
  loading: {
    fontSize: '4vmin',
    margin: 'auto'
  },
  header: {
    width: '100%'
  },
  local: {
    margin: 0,
    fontSize: '6vmin',
    letterSpacing: '0.08em',
    textTransform: 'uppercase'
  },
  sucursal: {
    margin: '0.5vh 0 0 0',
    fontSize: '3vmin',
    opacity: 0.7
  },
  sinLlamados: {
    margin: 'auto'
  },
  sinLlamadosTexto: {
    fontSize: '5vmin',
    opacity: 0.8
  },
  unicoWrap: {
    margin: 'auto'
  },
  unicoLabel: {
    margin: 0,
    fontSize: '4vmin',
    letterSpacing: '0.25em',
    opacity: 0.75
  },
  unicoNumero: {
    margin: 0,
    fontSize: '38vmin',
    fontWeight: 'bold',
    lineHeight: 1,
    color: '#6ee7b7'
  },
  restoNumeros: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '4vmin'
  },
  restoNumero: {
    fontSize: '24vmin',
    fontWeight: 'bold',
    lineHeight: 1,
    color: '#6ee7b7'
  },
  puestosGrid: {
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(28vmin, 1fr))',
    gap: '3vmin',
    width: '100%'
  },
  puestoCard: {
    background: 'rgba(255,255,255,0.07)',
    borderRadius: '3vmin',
    padding: '3vmin'
  },
  puestoLabel: {
    margin: 0,
    fontSize: '3.4vmin',
    letterSpacing: '0.2em',
    opacity: 0.75
  },
  puestoNumero: {
    margin: 0,
    fontSize: '18vmin',
    fontWeight: 'bold',
    lineHeight: 1.1,
    color: '#6ee7b7'
  },
  footer: {
    width: '100%'
  },
  espera: {
    margin: 0,
    fontSize: '4vmin',
    opacity: 0.85
  }
};

export default Display;
